import React, { ReactElement } from "react";
import Text, { TextType } from "components/Text";
import { ColorPalette } from "lib/styles/colors";

enum CurrentTextHighlight {
  BOLD = "bold",
  REGULAR = "regular",
}

interface SelectivelyHighlightedText {
  text: string;
  type: CurrentTextHighlight;
}
interface Props {
  text: string;
  searchTerm?: string;
  textType?: TextType;
  fontColor?: ColorPalette;
}

export default function SelectivelyHighlightedText({
  text,
  searchTerm,
  textType,
  fontColor,
}: Props): ReactElement {
  if (!searchTerm) {
    return (
      <Text
        type={textType ?? TextType.PARAGRAPH}
        fontColor={fontColor ?? undefined}
      >
        {text}
      </Text>
    );
  }
  const formattedTextArray = getFormattedTextArray(text, searchTerm);

  return (
    <span>
      {formattedTextArray.map((currText, index) => {
        return (
          <Text
            key={`text-highlight-${index}`}
            type={textType ?? TextType.PARAGRAPH_SPAN}
            style={
              currText.type === CurrentTextHighlight.BOLD
                ? {
                  backgroundColor: "#FBF719",
                  fontWeight: 800,
                  // opacity: 0.4,
                }
                : {
                  fontWeight: 400,
                  ...(fontColor && { color: `${fontColor}` }),
                }
            }
          >
            {currText.text}
          </Text>
        );
      })}
    </span>
  );
}

function getSubstringSections(options: {
  fullString: string;
  searchTerm: string;
  indexes: number[];
}) {
  const { fullString, searchTerm, indexes } = options;
  const textArr = [];
  if (!indexes.length) {
    return [fullString];
  }
  if (indexes.length === 1) {
    const endMatch = indexes[0] + searchTerm.length;
    textArr.push(fullString.slice(0, indexes[0]));
    textArr.push(fullString.slice(indexes[0], endMatch));
    textArr.push(fullString.slice(endMatch));
    return textArr;
  }
  for (let i = 0; i <= indexes.length; i++) {
    if (i === 0) {
      textArr.push(fullString.slice(0, indexes[i]));
      textArr.push(
        fullString.slice(indexes[i], indexes[0] + searchTerm.length)
      );
    } else if (i === indexes.length - 1) {
      textArr.push(fullString.slice(indexes[i], searchTerm.length));
    } else {
      textArr.push(fullString.slice(indexes[i], indexes[i + 1]));
    }
  }
  return textArr;
}
function getFormattedTextArray(
  text: string,
  searchTerm: string
): SelectivelyHighlightedText[] {
  // var re = /towing vessels/gi;
  // let indexes = [];
  // // @ts-ignore
  // while ((match = re.exec(text)) !== null) {
  //   // @ts-ignore
  //   indexes.push(match.index);
  // }
  const regex = new RegExp(searchTerm, "gi"); // correct way
  const matches = regex.exec(text); // it works
  const textArr = getSubstringSections({
    fullString: text,
    indexes: matches ? [matches.index] : [],
    searchTerm,
  });
  // IF NOT MATCH, just return text regular
  if (textArr.length === 1) {
    const output: SelectivelyHighlightedText[] = [
      {
        text: textArr[0],
        type: CurrentTextHighlight.REGULAR,
      },
    ];
    return output;
  }
  const output: SelectivelyHighlightedText[] = textArr.map((currText) => {
    if (searchTerm.toLowerCase() === currText.toLowerCase()) {
      return {
        text: currText,
        type: CurrentTextHighlight.BOLD,
      };
    } else {
      return {
        text: currText,
        type: CurrentTextHighlight.REGULAR,
      };
    }
  });
  return output;
}
